import React, { useEffect, useState, useMemo, act, useRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import moment from 'moment';

import Tab from 'components/common/Tab';
import { CityDropdownForTrip, CommonDateRange, CustomSelect } from 'components';
import { constant } from 'constants/constant';
import { getGpsVehicle, getNewGpsVehicles } from '_services';
import CommonDateTimeRange from 'components/common/CommonDateTimeRange';
import { FaPlay, FaStop } from 'react-icons/fa6';
import StorageService from 'utils/StorageServices';
import NewRunningVehicleGps from './NewRunningVehicleGps';
import Loading from 'pages/Loading';
import { Images } from 'constants';
import { getGpsTimeline, getStoppageGps, getSummaryGps, getTimeLineGPSData } from '_services/newGpsServices';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import { utils } from 'helper';
import CustomTooltip from "components/CustomTooltip/CustomTooltip";
import toast from 'react-hot-toast';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const NewGpsTimeline = (props) => {
    let { tripDetais } = props;

    const query = useQuery();
    const navigate = useNavigate();
    const location = useLocation();

    // Query params
    const tbn = query.get('tbn') || '0';
    const vn = query.get('vn') || '';
    const cmid = query.get('cmid') || '';

    const [isLoading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(Number(tbn));
    const [timeline, setTimeline] = useState([]);

    const [summaryData, setSummaryData] = useState([]);
    const [runingHistory, setRuningHistory] = useState([]);
    const [stoppage, setStoppage] = useState([]);

    const [vehicle, setVehicle] = useState([]);
    const [allVehicles, setVehicles] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [selectedDateTimeRange, setSelectedDateTimeRange] = useState({
        startDate: '',// moment().subtract(32, 'days').startOf('day').add(1, 'minute'),
        endDate: '', // moment().endOf('day'),
    });
    // const [gpsDate, setGpsDate] = useState(new Date());

    // Handle tab changes
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        const params = new URLSearchParams(location.search);
        params.set('tbn', tabId);
        navigate(`${location.pathname}?${params.toString()}`);
    };

    const [initialLoading, setInitialLoading] = useState(true);

    const containerRef = useRef(null);
    const offsetRef = useRef(1);
    const vehicleLoadingRef = useRef(false);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [offset, setOffset] = useState(1);
    const [vehicleLoading, setVehicleLoading] = useState(false);
    const [gpsTimeLineFetchData, setGpsTimeLineFetchData] = useState([]);
    const [mapTimeLineFetchData, setMapTimeLineFetchData] = useState([]);

    // Fetch GPS timeline
    const fetchGpsTimeline = async () => {
        if (!cmid || !vn) return;

        const startDate = selectedDateTimeRange?.startDate
            ? moment(selectedDateTimeRange.startDate).startOf('day').add(1, 'minute')
            : moment(new Date()); // moment().subtract(6, 'days').startOf('day').add(1, 'minute'); // 7-day range includes today

        const endDate = selectedDateTimeRange?.endDate
            ? moment(selectedDateTimeRange.endDate).endOf('day')
            : moment(new Date()); // moment().endOf('day'); // today's end of day

        const payload = {
            company_id: cmid,
            vehicle_no: vn,
            start_date: startDate.format('YYYY-MM-DDTHH:mm:ssZ'),
            end_date: endDate.format('YYYY-MM-DDTHH:mm:ssZ'),
            type: activeTab,
        };

        try {
            setLoading(true)
            const res = await getGpsTimeline(payload);
            if (res?.responseCode === 200) {
                setTimeline(res?.data?.timeline || []);
                setVehicle(res?.data?.vehicle || []);
            }
        } catch (error) {
            console.error('Error fetching GPS timeline', error);
        }
        finally {
            setLoading(false)
        }
    };

    const fetchTimelineGps = async () => {
        if (!cmid || !vn) return;

        const startDate = selectedDateTimeRange?.startDate
            ? moment(selectedDateTimeRange?.startDate).startOf('day').add(1, 'minute')
            : moment(new Date()); // moment().subtract(6, 'days').startOf('day').add(1, 'minute')

        const endDate = selectedDateTimeRange?.endDate
            ? moment(selectedDateTimeRange?.endDate).endOf('day')
            : moment(new Date()); // moment().endOf('day')

        const payload = {
            companyId: cmid,
            vehicleNo: vn,
            fromDate: startDate.format('YYYY-MM-DD'),
            toDate: endDate.format('YYYY-MM-DD'),
        };

        try {
            setLoading(true)
            const res = await getGpsTimeline(payload);
            if (res?.responseCode === 404) {
                return setRuningHistory([]);
            }
            if (res?.responseCode === 200) {
                setRuningHistory(res?.data)
            } else {
                if (res?.response?.data?.error) {
                    toast.error(res?.response?.data?.error);
                }
            }
        } catch (err) {
            if (err?.response?.data?.responseCode === 400) {
                toast.error(err?.response?.data?.error);
            }
            // console.error('Error fetching GPS timeline', error);
        }
        finally {
            setLoading(false)
        }
    };

    const fetchSummaryGps = async () => {
        if (!cmid || !vn) return;

        const startDate = selectedDateTimeRange?.startDate
            ? moment(selectedDateTimeRange.startDate).startOf('day').add(1, 'minute')
            : moment(new Date()); // moment().subtract(6, 'days').startOf('day').add(1, 'minute');

        const endDate = selectedDateTimeRange?.endDate
            ? moment(selectedDateTimeRange.endDate).endOf('day')
            : moment(new Date()); // moment().endOf('day');

        const payload = {
            companyId: cmid,
            vehicleNo: vn,
            fromDate: startDate.format('YYYY-MM-DD'),
            toDate: endDate.format('YYYY-MM-DD'),
        };

        try {
            setLoading(true)
            const res = await getSummaryGps(payload);
            if (res?.responseCode === 404) {
                return setSummaryData([]);
            }
            if (res?.responseCode === 200) {
                setSummaryData(res?.data);
            } else {
                if (res?.response?.data?.error) {
                    toast.error(res?.response?.data?.error);
                }
            }
        } catch (err) {
            if (err?.response?.data?.responseCode === 400) {
                toast.error(err?.response?.data?.error);
            }
            // console.error('Error fetching GPS timeline', error);
        }
        finally {
            setLoading(false)
        }
    };

    const fetchStoppageGps = async () => {
        if (!cmid || !vn) return;

        const startDate = selectedDateTimeRange?.startDate
            ? moment(selectedDateTimeRange.startDate).startOf('day').add(1, 'minute')
            : moment(new Date()); // moment().subtract(6, 'days').startOf('day').add(1, 'minute');

        const endDate = selectedDateTimeRange?.endDate
            ? moment(selectedDateTimeRange.endDate).endOf('day')
            : moment(new Date()); // moment().endOf('day');

        const payload = {
            companyId: cmid,
            vehicleNo: vn,
            fromDate: startDate.format('YYYY-MM-DD'),
            toDate: endDate.format('YYYY-MM-DD'),
        };

        try {
            setLoading(true)
            const res = await getStoppageGps(payload);
            if (res?.responseCode === 404) {
                return setStoppage([]);
            }
            if (res?.responseCode === 200) {
                setStoppage(res?.data);
            }
            else {
                if (res?.response?.data?.error) {
                    toast.error(res?.response?.data?.error);
                }
            }
        } catch (err) {
            if (err?.response?.data?.responseCode === 400) {
                toast.error(err?.response?.data?.error);
            }
            // console.error('Error fetching GPS timeline', error);
        }
        finally {
            setLoading(false)
        }
    };

    // Fetch vehicle list
    const fetchGpsVehicle = async () => {
        const payload = {
            companyId: cmid || StorageService.getCompanyId(),
            limit: 100,
            offset: 1,
            search: ''
        };

        try {
            const res = await getNewGpsVehicles(payload);
            if (res?.responseCode === 200) {
                setVehicles(res?.data || []);
            } else {
                if (res?.response?.data?.error) {
                    toast.error(res?.response?.data?.error);
                }
            }
        } catch (err) {
            // if (err?.response?.data?.responseCode === 400) {
            //     toast.error(err?.response?.data?.error);
            // }
            // console.error('Error fetching GPS vehicles', error);
        }
    };

    // Trigger vehicle fetch on mount
    useEffect(() => {
        fetchGpsVehicle();
    }, []);

    // Sync vehicle dropdown with query params
    useEffect(() => {
        if (tripDetais?.vehicle_id?.vehicle_no) {
            setSelectedVehicle({
                label: tripDetais?.vehicle_id?.vehicle_no,
                value: tripDetais?.vehicle_id?.vehicle_no,
                cmid: StorageService.getCompanyId(),
            });
            setSelectedDateTimeRange({
                startDate: tripDetais.dispatch_date ? moment(tripDetais.dispatch_date).format('YYYY-MM-DD') : moment(new Date()),
                endDate: tripDetais.end_date ? moment(tripDetais.end_date).format('YYYY-MM-DD') : moment(new Date()),
            });
            const params = new URLSearchParams(location.search);
            params.set('vn', tripDetais?.vehicle_id?.vehicle_no);
            params.set('cmid', StorageService.getCompanyId());
            navigate(`${location.pathname}?${params.toString()}`);
        } else {
            if (vn && cmid && allVehicles.length) {
                const matched = allVehicles.find(v => v.vehicle_no === vn);
                setSelectedVehicle(matched ? {
                    label: matched.vehicle_no,
                    value: matched.vehicle_no,
                    cmid: matched.company_id
                } : {
                    label: vn,
                    value: vn,
                    cmid
                });
                const params = new URLSearchParams(location.search);
                params.set('vn', matched?.vehicle_no ? matched?.vehicle_no : allVehicles[0]?.vehicle_no);
                params.set('cmid', matched?.company_id ? matched?.company_id : allVehicles[0]?.company_id);
                navigate(`${location.pathname}?${params.toString()}`);

            } else if (!vn && !cmid && allVehicles.length > 0) {
                setSelectedVehicle({
                    label: allVehicles[0]?.vehicle_no,
                    value: allVehicles[0]?.vehicle_no,
                    cmid: allVehicles[0]?.company_id
                })
                const params = new URLSearchParams(location.search);
                params.set('vn', allVehicles[0]?.vehicle_no);
                params.set('cmid', allVehicles[0]?.company_id);
                navigate(`${location.pathname}?${params.toString()}`);
            }
        }
    }, [vn, cmid, allVehicles, tripDetais?.vehicle_id?.vehicle_no]);

    // Tab prop config
    const tabProps = {
        tabList: constant.newGpsTrackerTabs,
        callBackTab: handleTabChange,
        activeTab
    };

    // On vehicle select
    const handleVehicleSelect = (item) => {
        setSelectedVehicle(item);
        const params = new URLSearchParams(location.search);
        params.set('vn', item?.value);
        params.set('cmid', item?.cmid);
        navigate(`${location.pathname}?${params.toString()}`);
    };

    // On date range apply
    const handleApplyDateRange = (range) => {
        setSelectedDateTimeRange(range)
        // setSelectedDateTimeRange({
        //     startDate: range.startDate,
        //     endDate: range.endDate,
        // });
    };

    // Dropdown options
    const vehicleOptions = useMemo(() => (
        allVehicles.map((v) => ({
            label: v.vehicle_no,
            value: v.vehicle_no,
            cmid: v.company_id
        }))
    ), [allVehicles]);

    // useEffect(() => {
    //     if (allVehicles?.length > 0) {
    // setSelectedVehicle({
    //     label: allVehicles[0]?.vehicle_no,
    //     value: allVehicles[0]?.vehicle_no,
    //     cmid: allVehicles[0]?.company_id
    // })
    // const params = new URLSearchParams(location.search);
    // params.set('vn', allVehicles[0]?.vehicle_no);
    // params.set('cmid', allVehicles[0]?.company_id);
    // navigate(`${location.pathname}?${params.toString()}`);
    //     }
    // }, [allVehicles])

    // const tripNumberFunction = (array) => {
    //     return array.map(el => el.trip_number);
    // }

    const fatchGpsTimeLineData = async (currentOffset) => {
        if (vehicleLoadingRef.current) return;

        vehicleLoadingRef.current = true;
        setVehicleLoading(true);

        try {
            const startDate =
                selectedDateTimeRange?.startDate
                    ? moment(selectedDateTimeRange.startDate).startOf('day').add(1, 'minute')
                    : moment(new Date()); // moment().subtract(6, 'days').startOf('day').add(1, 'minute');

            const endDate = selectedDateTimeRange?.endDate
                ? moment(selectedDateTimeRange.endDate).endOf('day')
                : moment(new Date()); // moment().endOf('day');

            const payload = {
                companyId: cmid,
                vehicleNo: vn,
                fromDate: startDate.format('YYYY-MM-DD'),
                toDate: endDate.format('YYYY-MM-DD'),
            };

            const query = {
                limit: 20,
                offset: currentOffset,
            };

            const res = await getTimeLineGPSData(payload, query);

            if (res?.responseCode === 200) {
                const gps_Data = res?.data?.timeline || [];
                const gps_map_Data = res?.data?.completeTimeline || [];
                const totalRecord = res?.totalResults || 0;

                const newData = currentOffset === 1 ? gps_Data : [...gpsTimeLineFetchData, ...gps_Data];
                const mapData = currentOffset === 1 ? gps_map_Data : [...mapTimeLineFetchData, ...gps_map_Data];

                setGpsTimeLineFetchData(newData);
                setMapTimeLineFetchData(mapData);

                if (newData.length >= totalRecord || !res?.hasMore) {
                    setHasMoreData(false);
                } else {
                    setHasMoreData(true);
                    const nextOffset = currentOffset + 1;
                    setOffset(nextOffset);
                    offsetRef.current = nextOffset;
                }
            } else {
                if (res?.response?.data?.error) {
                    toast.error(res?.response?.data?.error);
                }
            }
        } catch (err) {
            if (err?.response?.data?.responseCode === 400) {
                toast.error(err?.response?.data?.error);
            }
            setHasMoreData(false);
        } finally {
            vehicleLoadingRef.current = false;
            setVehicleLoading(false);
        }
    }

    const handleScroll = () => {
        const el = containerRef.current;
        if (!el || vehicleLoadingRef.current || !hasMoreData) return;

        const threshold = 200;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
            fatchGpsTimeLineData(offsetRef.current);
        }
    };

    const fetchInitialData = () => {
        if (!vehicleLoadingRef.current) {
            fatchGpsTimeLineData(1);
        }
    };

    useEffect(() => {
        if (vn && activeTab === 0) {
            fetchSummaryGps();
        }
        if (vn && activeTab === 1) {
            fetchTimelineGps();
        }
        if (vn && activeTab === 2) {
            setOffset(1);
            offsetRef.current = 1;
            setGpsTimeLineFetchData([]);
            setMapTimeLineFetchData([]);
            setHasMoreData(true);
            fetchInitialData();
        }
        if (vn && activeTab === 3) {
            fetchStoppageGps();
        }
    }, [cmid, vn, selectedDateTimeRange.startDate, selectedDateTimeRange.endDate, activeTab]);

    const fetchFromCity = async (search, page, limit) => {
        const res = await getNewGpsVehicles({
            companyId: StorageService.getCompanyId(),
            // offset: page,
            page: page,
            limit,
            search,
        });
        if (res?.responseCode === 200) {
            const list = res?.data?.map((c) => ({ ...c, value: c.vehicle_no, label: c.vehicle_no, _id: c.id }))
            return {
                items: [...list],
                total: res?.totalResults,
            };
        } else {
            toast.error(res?.responseMessage);
        }
    };

    const handleTripNavigate = (item)=>{
        navigate(`/trip/addtrip/dispatched/${item?._id}?t=gps`)
    }

    return (
        <div className="__mainGps_bx">
            <div className="addPr_flBx">
                <div className="_secFilts_gps" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Tab {...tabProps} />
                    <div className="llt_dash_branch_date">

                        {!tripDetais?.vehicle_id?.vehicle_no ? <div className="__gpsDateRange">
                            {/* <DatePickerComponent
                                label="Date "
                                name="date"
                                showTimeSelect={false}
                                defaultTimeFix={false}
                                startDate={gpsDate}
                                onChange={(data) => setGpsDate(data)}
                            /> */}
                            <CommonDateRange
                                initialStartDate={selectedDateTimeRange?.start_date}
                                initialEndDate={selectedDateTimeRange?.end_date}
                                onApply={handleApplyDateRange}
                                isDefaultToday={true}
                            />
                        </div> : <></>}

                        {!tripDetais?.vehicle_id?.vehicle_no ? <div className="__gpsVehicleSelect __newGpsVehSelect">
                            {/* <CustomSelect
                                options={vehicleOptions}
                                name="vehicle_no"
                                label="Select Vehicle"
                                placeholder="Select Vehicle"
                                value={selectedVehicle}
                                onSelect={handleVehicleSelect}
                            /> */}
                            <CityDropdownForTrip
                                inputClass="__newGpsVeh"
                                key={`vehicle`}
                                label="Vehicle"
                                placeholder="Vehicle"
                                fetchData={fetchFromCity}
                                pageSize={20}
                                selectedItem={selectedVehicle}
                                onChange={handleVehicleSelect}
                                withState={false}
                            />
                        </div> : <></>}
                    </div>
                </div>

                {activeTab == 0 &&
                    <div className='__gpsSummary_bx'>
                        <div className='__gpsSummary_inr __gpsSummary_runningTab'>
                            <div className='__gpsSummary_item'>
                                <table>
                                    <thead>
                                        <tr>
                                            <td><div className='__txt_sphire'>Vehicle</div></td>
                                            <td><div className='__txt_sphire'>Vehicle Avg</div></td>
                                            <td><div className='__txt_sphire'>Running KM</div></td>
                                            <td><div className='__txt_sphire'>Idle KM </div></td>
                                            <td><div className='__txt_sphire'>Running Time</div></td>
                                            <td><div className='__txt_sphire'>Stopped Duration</div></td>
                                            <td><div className='__txt_sphire'>Ideal Duration</div></td>
                                            <td><div className='__txt_sphire'>GPS Fuel Consumed</div></td>
                                            <td><div className='__txt_sphire'>GPS Inactive</div></td>
                                            <td><div className='__txt_sphire'>Unreachable Duration</div></td>
                                            <td><div className='__txt_sphire'>Alerts</div></td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {summaryData?.map((el, ind) => {
                                            return (
                                                <tr key={ind}>
                                                    <td><div className='__txt_sphire'> {el?.status ? utils.firstLetterCapital(el?.status) : '-'} </div></td>
                                                    <td><div className='__txt_sphire'> - </div></td>
                                                    <td><div className='__perCent_bxx'><div className='__txt_sphire'> {(el?.total_idle_distance_km + el?.total_running_distance_km)?.toFixed(2)} </div><span style={{ backgroundColor: 'rgba(242, 255, 239, 1)' }}></span></div></td>
                                                    <td><div className='__txt_sphire'> {el?.total_idle_distance_km} </div></td>
                                                    <td><div className='__txt_sphire'> {el?.total_running_time} </div></td>
                                                    <td><div className='__txt_sphire'>{el?.total_parked_time}</div></td>
                                                    <td><div className='__txt_sphire'>{el?.total_idle_time}</div></td>
                                                    <td><div className='__txt_sphire'> - </div></td>
                                                    <td><div className='__txt_sphire'> - </div></td>
                                                    <td><div className='__perCent_bxx'><div className='__txt_sphire'>{el?.total_unreachable_time}</div><span style={{ backgroundColor: 'rgba(242, 255, 239, 1)' }}></span></div></td>
                                                    <td><div className='__txt_sphire'> - </div></td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>

                                    {/* <tfoot>
                                        <tr>
                                            <td><div className='__txt_sphire'>Total Running</div></td>
                                            <td><div className='__txt_sphire'> - </div></td>
                                            <td><div className='__perCent_bxx'><div className='__txt_sphire'> {(summaryData?.total_idle_distance_km + summaryData?.total_running_distance_km)?.toFixed(2)} </div><span style={{ backgroundColor: 'rgba(242, 255, 239, 1)' }}></span></div></td>
                                            <td><div className='__txt_sphire'> {summaryData?.empty_running_time} </div></td>
                                            <td><div className='__txt_sphire'> {summaryData?.loaded_running_time} </div></td>
                                            <td><div className='__txt_sphire'> - </div></td>
                                            <td><div className='__perCent_bxx'><div className='__txt_sphire'>{summaryData?.total_running_time}</div><span style={{ backgroundColor: 'rgba(242, 255, 239, 1)' }}></span></div></td>
                                            <td><div className='__txt_sphire'>{summaryData?.total_parked_time}</div></td>
                                            <td><div className='__txt_sphire'>{summaryData?.total_idle_time}</div></td>
                                            <td><div className='__txt_sphire'> - </div></td>
                                            <td><div className='__txt_sphire'> - </div></td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                            </div>
                        </div>
                    </div>
                }

                {activeTab == 1 &&
                    <div className="__fltTier_tableBx">
                        <table>
                            <thead>
                                <tr>
                                    <th>Vehicle</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                    <th>Start Location</th>
                                    <th>End Location</th>
                                    <th>Distance</th>
                                    <th>Duration</th>
                                    <th>Avarage Speed</th>
                                    <th> Progress </th>
                                    <th> Status </th>
                                    <th>Running Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ?
                                    <tr>
                                        <td colSpan={10}><div className='__fltHist_txs' style={{ textAlign: 'center' }}>Loading...</div></td>
                                    </tr>
                                    :
                                    runingHistory.length > 0 ? (
                                        runingHistory.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td><div className='__fltHist_txs'>{item?.vehicle_no}</div></td>
                                                    <td>
                                                        <div className='__fltHist_txs'>{item?.fromDate ? moment(item?.fromDate).format('DD MMM yyyy') : '-'}</div>
                                                        <div className='__fltHist_txs'>{item?.fromTime}</div>
                                                    </td>
                                                    <td>
                                                        <div className='__fltHist_txs'>{item?.toDate ? moment(item?.toDate).format('DD MMM yyyy') : '-'}</div>
                                                        <div className='__fltHist_txs'>{item?.toTime}</div>
                                                    </td>
                                                    <td>
                                                        <div className='__fltHist_txs'>
                                                            {(() => {
                                                                const name = item?.startLocation || "";
                                                                const value = String(name);

                                                                return value.length > 20 ? (
                                                                    <CustomTooltip
                                                                        txtClass="__tooltipTxt_bx"
                                                                        cstStyle={{ maxWidth: "138px" }}
                                                                    >
                                                                        <p>{value}</p>
                                                                    </CustomTooltip>
                                                                ) : (
                                                                    <div className="__NottooltipTxt">
                                                                        <p>{value ? value : '-'}</p>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='__fltHist_txs'>
                                                            {(() => {
                                                                const name = item?.endLocation || "";
                                                                const value = String(name);

                                                                return value.length > 20 ? (
                                                                    <CustomTooltip
                                                                        txtClass="__tooltipTxt_bx"
                                                                        cstStyle={{ maxWidth: "138px" }}
                                                                    >
                                                                        <p>{value}</p>
                                                                    </CustomTooltip>
                                                                ) : (
                                                                    <div className="__NottooltipTxt">
                                                                        <p>{value ? value : '-'}</p>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    <td><div className='__fltHist_txs'>{item?.distance ? `${Math.floor(item?.distance * 1000) / 1000} KM` : '-'}</div></td>
                                                    {/* <td><div className='__fltHist_txs'>{(item?.fromDate && item?.fromTime && item?.toDate && item?.toTime) ? utils.getDuration(item?.fromDate, item?.fromTime, item?.toDate, item?.toTime) : '-'}</div></td> */}
                                                    {/* <td><div className='__fltHist_txs'> {(item?.fromDate && item?.fromTime && item?.toDate && item?.toTime && item?.distance) ? utils?.getAvarageSpeed(item?.fromDate, item?.fromTime, item?.toDate, item?.toTime, item?.distance) : '-'} </div></td> */}

                                                    <td><div className='__fltHist_txs'>{item?.duration ? item?.duration : '-'}</div></td>
                                                    <td><div className='__fltHist_txs'> {item?.average_speed ? `${item?.average_speed} km/h` : '-'} </div></td>
                                                    <td>
                                                        {item?.inProgress ?
                                                            <span className='_lrBillRaised_status'>
                                                                In Progress
                                                            </span>
                                                            :
                                                            <span className='_lrDelivered_status'>
                                                                Completed
                                                            </span>
                                                        }
                                                    </td>
                                                    <td>
                                                        {item?.trips?.length > 0 ?
                                                         item?.trips?.map((el,ind)=>{
                                                            return(
                                                            <div key={ind+36} className="_separateBxs mb-1" onClick={()=>handleTripNavigate(el)}>
                                                                <Link className="_trip_ind me-2" >
                                                                    <span>Trip</span>
                                                                    <div className="trpCode">
                                                                        {el?.trip_number}
                                                                    </div>
                                                                </Link>
                                                            </div> 
                                                            )
                                                         })
                                                            : '-'}
                                                    </td>

                                                    <td>
                                                        <div className='__empty_txs'>
                                                            {item?.status}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={10} style={{ textAlign: 'center' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                    <img src={Images.NoRecordFound} alt="" />
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>
                }

                {activeTab === 2 && (
                    <div className='__fltTierBx'>
                        <div className='__flxTierDx'>
                            <div className='__gpsTimeLine_bx' ref={containerRef} onScroll={handleScroll}>
                                {isLoading ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                        <Loading />
                                    </div>
                                    : gpsTimeLineFetchData.length > 0 ? (
                                        gpsTimeLineFetchData.map((item, index) => {
                                            return (<div className='__fltsFlects_main' key={index}>
                                                <div className='__fltsFlects_time'>
                                                    <div>
                                                        <h4>{item?.fromDate ? moment(item?.fromDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '-'}</h4>
                                                        <p>{item?.fromTime}</p>
                                                    </div>

                                                    <div>
                                                        <h4>{item?.toDate ? moment(item?.toDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '-'}</h4>
                                                        <p>{item?.toTime ? item?.toTime : '-'}</p>
                                                    </div>
                                                </div>
                                                {/* ${item.status === 'Running' ? '__fltsFlects_running' : '__fltsFlects_stop'} */}
                                                <div className={`__fltsFlects_detail`} style={{ color: (item.status === 'Running') ? '#00c853' : (item.status === 'Idle' ? '#FFAC05' : (item.status === "Parked" ? '#d50000' : '#d50000')) }}>
                                                    {/* <div className={`__fltsFlects_detail`} style={{ color: (item.status === 'Running') ? '#00c853' : '#d50000' }}> */}
                                                    <span className='__verLine_flt'></span>

                                                    <div className='__fltsDetail_inr'>
                                                        <h4>{item.status}</h4>
                                                        <div className='gps_tracker_s'>
                                                            {item.status === 'Running' ? (item?.distance ? <ul><li>{`${Math.floor(item?.distance * 1000) / 1000} KM`}</li></ul> : '') : ''}
                                                            {item?.duration ? <ul><li>{item?.duration}</li></ul> : ''}
                                                        </div>
                                                        <p>{item?.startLocation ? item?.startLocation : ''}</p>
                                                        <p>{item?.endLocation ? item?.endLocation : ''}</p>
                                                        {/* {item.status === 'Running' && <h5>Distance {item?.distance ? `${Math.floor(item?.distance * 1000) / 1000} KM` : '-'}</h5>}
                                                        <h5>Duration {item?.duration ? item?.duration : '-'}</h5>
                                                        <h5>Average speed {item?.average_speed ? `${Math.floor(item?.average_speed * 100) / 100} km/h` : '-'}</h5>
                                                        */}
                                                    </div>
                                                </div>
                                            </div>
                                            );
                                        })
                                    ) : (vehicleLoading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                        <Loading />
                                    </div> :
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                            <img src={Images.NoRecordFound} alt="" />
                                        </div>
                                    )}
                            </div>

                            <NewRunningVehicleGps timeline={mapTimeLineFetchData} />
                        </div>
                    </div>
                )}

                {activeTab == 3 &&
                    <div className="__fltTier_tableBx">
                        <table>
                            <thead>
                                <tr>
                                    <th>Vehicle</th>
                                    <th>Stop Time</th>
                                    <th>Start Time</th>
                                    <th>Location</th>
                                    <th>Nearest Location</th>
                                    <th>After Distance</th>
                                    <th>Duration</th>
                                    <th>Avarage Speed</th>
                                    <th> Progress </th>
                                    <th> Status </th>
                                    <th>Running Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ?
                                    <tr>
                                        <td colSpan={10}><div className='__fltHist_txs' style={{ textAlign: 'center' }}>Loading...</div></td>
                                    </tr>
                                    : stoppage.length > 0 ? (
                                        stoppage.map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  <div className="__fltHist_txs">
                                                    {item?.vehicle_no
                                                      ? item?.vehicle_no
                                                      : "-"}
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="__fltHist_txs">
                                                    {item?.fromDate
                                                      ? moment(
                                                          item?.fromDate
                                                        ).format("DD MMM yyyy")
                                                      : "-"}
                                                  </div>
                                                  <div className="__fltHist_txs">
                                                    {item?.fromTime}
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="__fltHist_txs">
                                                    {item?.toDate
                                                      ? moment(
                                                          item?.toDate
                                                        ).format("DD MMM yyyy")
                                                      : "-"}
                                                  </div>
                                                  <div className="__fltHist_txs">
                                                    {item?.toTime}
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="__fltHist_txs">
                                                    {(() => {
                                                      const name =
                                                        item?.startLocation ||
                                                        "";
                                                      const value =
                                                        String(name);
                                                      return value.length >
                                                        20 ? (
                                                        <CustomTooltip
                                                          txtClass="__tooltipTxt_bx"
                                                          cstStyle={{
                                                            maxWidth: "138px",
                                                          }}
                                                        >
                                                          <p>{value}</p>
                                                        </CustomTooltip>
                                                      ) : (
                                                        <div className="__NottooltipTxt">
                                                          <p>
                                                            {value
                                                              ? value
                                                              : "-"}
                                                          </p>
                                                        </div>
                                                      );
                                                    })()}
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="__fltHist_txs">
                                                    {(() => {
                                                      const name =
                                                        item?.endLocation || "";
                                                      const value =
                                                        String(name);

                                                      return value.length >
                                                        20 ? (
                                                        <CustomTooltip
                                                          txtClass="__tooltipTxt_bx"
                                                          cstStyle={{
                                                            maxWidth: "138px",
                                                          }}
                                                        >
                                                          <p>{value}</p>
                                                        </CustomTooltip>
                                                      ) : (
                                                        <div className="__NottooltipTxt">
                                                          <p>
                                                            {value
                                                              ? value
                                                              : "-"}
                                                          </p>
                                                        </div>
                                                      );
                                                    })()}
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="__fltHist_txs">
                                                    {item?.distance
                                                      ? `${
                                                          Math.floor(
                                                            item?.distance *
                                                              1000
                                                          ) / 1000
                                                        } KM`
                                                      : "-"}
                                                  </div>
                                                </td>
                                                {/* <td><div className='__fltHist_txs'>{(item?.fromDate && item?.fromTime && item?.toDate && item?.toTime) ? utils.getDuration(item?.fromDate, item?.fromTime, item?.toDate, item?.toTime) : '-'}</div></td>
                                                    <td><div className='__fltHist_txs'> {(item?.fromDate && item?.fromTime && item?.toDate && item?.toTime && item?.distance) ? utils?.getAvarageSpeed(item?.fromDate, item?.fromTime, item?.toDate, item?.toTime, item?.distance) : '-'} </div></td> */}
                                                <td>
                                                  <div className="__fltHist_txs">
                                                    {item?.duration
                                                      ? item?.duration
                                                      : "-"}
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="__fltHist_txs">
                                                    {" "}
                                                    {item?.average_speed
                                                      ? `${item?.average_speed} km/h`
                                                      : "-"}{" "}
                                                  </div>
                                                </td>
                                                <td>
                                                  {item?.inProgress ? (
                                                    <span className="_lrBillRaised_status">
                                                      In Progress
                                                    </span>
                                                  ) : (
                                                    <span className="_lrDelivered_status">
                                                      Completed
                                                    </span>
                                                  )}
                                                </td>
                                                <td>
                                                  {item?.trips?.length > 0 ? (
                                                    item?.trips?.map((el,ind)=>{
                                                        return(
                                                        <div key={ind+35} className="_separateBxs mb-1" onClick={()=>handleTripNavigate(el)}>
                                                            <Link className="_trip_ind me-2" >
                                                                <span>Trip</span>
                                                                <div className="trpCode">
                                                                    {el?.trip_number}
                                                                </div>
                                                            </Link>
                                                        </div> 
                                                        )
                                                     })
                                                  ) : (
                                                    "-"
                                                  )}
                                                </td>
                                                <td>
                                                  <div className="__empty_txs">
                                                    {item?.status}
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={10} style={{ textAlign: 'center' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                    <img src={Images.NoRecordFound} alt="" />
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>}


            </div>
        </div>
    );
};

export default NewGpsTimeline;
